import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import '../../assests/css/students/StatsCounter.css';
import { AppContext } from '../../context/Appcontext';

const StatsCounter = () => {

  // Separate states
  const [students, setStudents] = useState(0);
  const [teachers, setTeachers] = useState(0);
  const [courses, setCourses] = useState(0);
  const [success, setSuccess] = useState(0);

  const {baseUrl} = useContext(AppContext);

  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);

  // Fetch stats from API
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}/stats`
        );

        if (response.data.success) {
          const data = response.data.data;

          setStudents(Number(data.students) || 0);
          setTeachers(Number(data.teachers) || 0);
          setCourses(Number(data.courses) || 0);
          setSuccess(Number(data.attendance_rate) || 0);
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
      }
    };

    fetchStats();
  }, []);

  // Counter animation
  useEffect(() => {
    if (
      students === 0 &&
      teachers === 0 &&
      courses === 0 &&
      success === 0
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [students, teachers, courses, success, hasAnimated]);

  const animateCounters = () => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    const targetStudents = students;
    const targetTeachers = teachers;
    const targetCourses = courses;
    const targetSuccess = success;

    let step = 0;

    const timer = setInterval(() => {
      step++;

      const progress = step / steps;
      const easeOut = 1 - Math.pow(1 - progress, 3);

      setStudents(Math.floor(targetStudents * easeOut));
      setTeachers(Math.floor(targetTeachers * easeOut));
      setCourses(Math.floor(targetCourses * easeOut));
      setSuccess(Math.floor(targetSuccess * easeOut));

      if (step >= steps) {
        clearInterval(timer);

        setStudents(targetStudents);
        setTeachers(targetTeachers);
        setCourses(targetCourses);
        setSuccess(targetSuccess);
      }
    }, interval);
  };

  return (
    <section className="sc-stats-section" ref={sectionRef}>

      <div className="sc-stats-container">

        {/* Students */}
        <div className="sc-stat-item">
          <h2 className="sc-stat-number">
            {students}
          </h2>

          <p className="sc-stat-label">
            Students Enrolled
          </p>
        </div>

        {/* Teachers */}
        <div className="sc-stat-item">
          <h2 className="sc-stat-number">
            {teachers}
          </h2>

          <p className="sc-stat-label">
            Expert Teachers
          </p>
        </div>

        {/* Courses */}
        <div className="sc-stat-item">
          <h2 className="sc-stat-number">
            {courses}
          </h2>

          <p className="sc-stat-label">
            Courses Available
          </p>
        </div>

        {/* Success Rate */}
        <div className="sc-stat-item">
          <h2 className="sc-stat-number">
            {success}%
          </h2>

          <p className="sc-stat-label">
            Daily Attendence 
          </p>
        </div>

      </div>

    </section>
  );
};

export default StatsCounter;